import { makeAutoObservable } from 'mobx';
import { storageHelper } from '@/utils';
import { getTotalPrice } from '@/components/comboDetail/utils/getPrice';
import { cloneDeep } from 'lodash';
class comboStore {
  constructor() {
    makeAutoObservable(this);
  }

  interceptComboList = (key: string, value: any) => {
    if (key === 'comboList') {
      storageHelper.setItem('__combo_list', value);
    }
  }
  
  updateState = (params: { [key: string]: any }) => {
    for (const [key, value] of Object.entries(params)) {
      this.interceptComboList(key, value);
      (this as any)[key] = value;
    }
  }

  changeComboCount = (index: number, count: number) => {
    // 浅拷贝 comboList
    const comboList = [...this.comboList];
    // 获取指定索引的 combo 项
    const findComboItem = comboList[index];
  
    if (count < 1) {
      // 删除 combo
      comboList.splice(index, 1);
    } else if (findComboItem) {
      // 更改 combo 数量
      comboList[index] = { 
        ...findComboItem, 
        count: count,
        comboSubTotalPrice: getTotalPrice({ unitPrice: findComboItem?.comboPrice, count })
       };
    }
  
    this.updateState({ comboList });
  }
  

  changeCombo = (index: number, data: any) => {
    const comboList = cloneDeep(this.comboList);
    const findComboItem = comboList[index];
    // 更改combo
    if (findComboItem) {
      comboList[index] = data;
    }
    this.updateState({ comboList });
  }

  clearCombo = () => {
    this.updateState({ comboList: [] });
  }


  addCombo = (comboState: any) => {
    if (!comboState) return;
    this.updateState({
      comboList: [...(this.comboList || []), comboState],
    })
  }
  
  deleteCombo = () => {
    this.updateState({ comboList: [] });
  }
  deleteSpecificCombo = (deleteComboIds:any) => {
    const comboList = storageHelper.getItem('__combo_list');
    if(comboList && comboList.length > 0)  {
      const filteredData = comboList.filter((item: { comboId: string; }) => !deleteComboIds.includes(item.comboId));
    this.updateState({ comboList:filteredData });
    console.log(JSON.stringify(filteredData),'comboList');
    }
    
  }
  comboList: any = [];

}

export default new comboStore();